import { render, staticRenderFns } from "./AccountsWithAttorney.vue?vue&type=template&id=14bb156d&"
import script from "./AccountsWithAttorney.vue?vue&type=script&lang=js&"
export * from "./AccountsWithAttorney.vue?vue&type=script&lang=js&"
import style0 from "./AccountsWithAttorney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports